import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MaterialModule } from "../../core/shared/material.module";

@Component({
  selector: "app-connection-card",
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: "./connection-card.component.html",
  styleUrl: "./connection-card.component.scss",
})
export class ConnectionCardComponent {
  @Input() connection: any;
  @Input() isTesting = false;
  @Input() showTest = true;
  @Input() showEdit = true;
  @Input() showDelete = true;

  @Output() test = new EventEmitter<MouseEvent>();
  @Output() edit = new EventEmitter<MouseEvent>();
  @Output() delete = new EventEmitter<MouseEvent>();
  @Output() nameClick = new EventEmitter<MouseEvent>();

  /** Avatar fills must come from `colors.scss` under `//new colors` only. */
  private readonly avatarColors = [
    "#5f2cff", // $royal-purple
    "#38369A", // $medium-purple
    "#1E2345", // $dark-purple
    "#00434A", // $medium-green
    "#052D2A", // $dark-green
    "#FC404A", // $ruby-red
    "#C105B3", // $raspberry
    "#151C28", // $coal
    "#242933", // $coal-95
    "#424751", // $coal-80
    "#73777E", // $coal-60
    "#FEC901", // $amber
    "#02F576", // $bright-green
  ];

  get name(): string {
    return this.connection?.connectionName || this.connection?.name || "";
  }

  get initial(): string {
    return this.name.trim() ? this.name.trim()[0].toUpperCase() : "";
  }

  get avatarColor(): string {
    const name = this.name;
    if (!name) {
      return this.avatarColors[0];
    }
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return this.avatarColors[Math.abs(hash) % this.avatarColors.length];
  }

  get providerLabel(): string {
    return (
      this.connection?.meta?.displayName ||
      this.connection?.meta?.source ||
      ""
    );
  }

  get modelLabel(): string {
    return (
      this.connection?.meta?.model ||
      this.connection?.modelName ||
      this.connection?.meta?.modelName ||
      ""
    );
  }
}
